/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminUser,
    AdminUserFromJSON,
    AdminUserToJSON,
    CreateUser,
    CreateUserFromJSON,
    CreateUserToJSON,
    CreateUserResponse,
    CreateUserResponseFromJSON,
    CreateUserResponseToJSON,
} from '../models';

export interface AdminApiAdminCreateUserRequest {
    user: CreateUser;
}

export function createAdminAllUsersPath(): string {
    return `/admin/users`;
}
export function createAdminAllUsersFullPath(): string {
    return runtime.BASE_PATH + `/admin/users`;
}
export function createAdminCreateUserPath(): string {
    return `/admin/users`;
}
export function createAdminCreateUserFullPath(): string {
    return runtime.BASE_PATH + `/admin/users`;
}

/**
 *
 */
export class AdminApi extends runtime.BaseAPI {
    /**
     * Get all users
     * Get all users
     */
    async adminAllUsers(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<Array<AdminUser>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminAllUsersPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminUserFromJSON))
        );
    }
    /**
     * Create a new user
     * Create a new user
     */
    async adminCreateUser(
        requestParameters: AdminApiAdminCreateUserRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<CreateUserResponse>> {
        if (requestParameters?.user === null || requestParameters?.user === undefined) {
            throw new runtime.RequiredError(
                'user',
                'Required parameter requestParameters.user was null or undefined when calling adminCreateUser.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminCreateUserPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: CreateUserToJSON(requestParameters?.user),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => CreateUserResponseFromJSON(jsonValue))
        );
    }
}
